import DOMPurify from "dompurify";

export const HTML = (props) => {
  const { content } = props;

  return (
    <div dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(content) }} />
  );
};
